export const ZILL_CURRICULUM_SOURCE_NAME = 'ZiLL';
export const ZILL_API_URL = 'https://cached-api.katholiekonderwijs.vlaanderen';
export const ZILL_SELECTOR_URL = 'https://zill-selector.katholiekonderwijs.vlaanderen';
export const COMPOSED_TITLE_PATH_SEPARATOR = ' >> ';